<template>
  <v-col>
    <v-row class="pa-2">
      <v-col class="pa-2">
        <dashboard-card
          :report-code-includes="reportCodeIncludes"
          :selected-item="dashboardForm"
        />
      </v-col>
    </v-row>

    <v-row class="mt-0 pa-2">
      <v-col
        v-for="(dashboardCard, dashboardCardIndex) in dashboardBarCards"
        :key="dashboardCardIndex"
        class="pa-2"
      >
        <dashboard-card
          :data-index="dashboardCardIndex"
          :report-code-includes="reportCodeIncludes"
          :selected-item="dashboardCard"
        />
      </v-col>
    </v-row>

    <dashboard-modals />
  </v-col>
</template>

<script>
import DashboardMixin from 'src/dashboard/store/utils/dashboard-mixin'

export default {
  name: 'DashboardBar',
  components: {
    DashboardCard: () => import('src/dashboard/components/DashboardCard'),
    DashboardModals: () => import('src/dashboard/components/DashboardModals'),
  },
  mixins: [
    DashboardMixin,
  ],
  computed: {
    dashboardBarCards() {
      return this.dashboards
    },
    dashboardForm() {
      return this.emptyDashboardCard
    },
    reportCodeIncludes() {
      const { associationId, subId } = this.$route.query
      return [{ associationId, subId }]
    },
  },
}
</script>
